// features/bookmarks/panels/RecentlySavedPanel.tsx — 4 most-recently-saved.
import styled from 'styled-components';
import { Panel, SectionLabel } from '@/ui';
import { Icon } from '@/icons';
import type { Bookmark } from '@/core/models/bookmark';
import { TYPE_META } from '../meta';
import { recentlySaved } from '../filterBookmarks';

export interface RecentlySavedPanelProps { bookmarks: Bookmark[]; }

const List = styled.ul`list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px;`;
const Item = styled.li`
  display: flex; align-items: center; gap: 8px;
  font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textPrimary};
`;
const Title = styled.span`flex: 1; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;`;
const Time = styled.span`flex: none; font-size: ${({ theme }) => theme.fontSize.xs}; color: ${({ theme }) => theme.color.textMuted};`;

export function RecentlySavedPanel({ bookmarks }: RecentlySavedPanelProps) {
  const rows = recentlySaved(bookmarks, 4);
  return (
    <Panel>
      <SectionLabel as="h2">Recently Saved</SectionLabel>
      <List>
        {rows.map((b) => (
          <Item key={b.id}>
            <Icon name={TYPE_META[b.type].icon} size={16} />
            <Title>{b.title}</Title>
            <Time>{b.time}</Time>
          </Item>
        ))}
      </List>
    </Panel>
  );
}
